import {jQuery as $, lodash as _} from 'lib/shim';



const SELECTOR = ['.atom-select', 'select'];



class AtomSelect {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;
			this._$selectric = $();

			this._prime();
		}

		return $element;
	}



	_prime(){
		this._$element.selectric({
			nativeOnMobile: true,
			arrowButtonMarkup: '<span class="button"></span>',
			labelBuilder: (currItem) => {
				if (currItem.index === 0 && !currItem.value && currItem.selected) {
					return '<span class="default">'+currItem.text+'</span>';
				}
				return currItem.text;
			}
		});
		this._$selectric = this._$element.closest('.selectric-wrapper');

		this._$selectric.on('click', (e) => {
			_.defer(() => {
				if( this._$selectric.hasClass('selectric-open') ){
					this._$element.selectric('close');
				}
			});
		});

		// this._$element.on('selectric-change', (event, element, selectric) => {
		// 	$.log(event, element, selectric);
		// });

		if( this._$element.hasClass('error') ){
			this._$element.closest('.atom-inputlabel').addClass('error');
		}

		if( this._$element.is(':disabled') ){
			this._$element.closest('.atom-inputlabel').addClass('disabled');
		}
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new AtomSelect(app, $this));
	});

	return $elements;
}
